<!-- 关于我们 -->
<template>
  <div class="frame">
    <Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="wrap">
      <div class="box">
        <div class="title-box">
          <div class="title">中心简介</div>
        </div>
        <div class="content">
          <div class="intro">
            <div class="origin">
              四川省建协人才服务中心成立于<span>2020</span>年初
            </div>
            <div class="addr">中心地址：成都市武侯区二环路西一段。</div>
            <p>
              本中心由市场拓展部，人力资源部，中介合作管理部等多个部门以及个体团队组成，是一支专业配置齐全、年龄结构合理的高素质人才队伍，逐步建立健全了一套科学先进的目标管理体系、安全评价体系、人才测评体系、财务经营体系、质量监督管理体系。积极参与市场竞争和挑战。
            </p>
          </div>
          <div class="type-title">直营下小组</div>
          <div class="types">
            <div class="type">职业技能鉴定小组</div>
            <div class="type">职业资格认定小组</div>
            <div class="type">工程机械技术人员认定小组</div>
            <div class="type">
              技术人员资格评审建筑工程类技术人员认定（简称职称评委会小组）
            </div>
          </div>
        </div>
      </div>
      <div class="scope">
        <div class="title-box">
          <div class="title">行政许可经营范围</div>
        </div>
        <div class="content">
          <div class="left">
            <div class="list">
              <div class="item">职业中介服务</div>
              <div class="item">职业技能鉴定</div>
              <div class="item">职业资格认定</div>
              <div class="item">专业技术人员资格评审</div>
              <div class="item">建筑工程类技术人员认定</div>
              <div class="item">工程机械技术人员认定</div>
              <div class="item">职业技能教材的编辑、推广</div>
              <div class="item">职业技能社会化考试大纲编辑</div>
              <div class="item">就业指导</div>
              <div class="item">档案管理</div>
              <div class="item">人力资源信息服务</div>
              <div class="item">教育咨询</div>
            </div>
          </div>
          <img src="@/assets/certification.jpg" alt="" class="right" />
        </div>
      </div>
      <div class="box">
        <div class="title-box">
          <div class="title">中心愿景</div>
        </div>
        <div class="content">
          <div class="hope">
            <p>
              作为发展四川省建设领域人才培养事业的重要力量，团结全省各个建设领域工作者，坚定贯彻党的路线、方针、政策；
            </p>
            <p>
              严格遵守国家宪法、法律、法规和国家政策，遵守社会道德风尚，坚持“百花齐放、百家争鸣”的方针;坚持实事求是、与时俱进的科学态度和优良作风；
            </p>
            <p>
              倡导“献身、创新、求实、协作”的精神;以科学发展观为指导，坚持以人为本，民主办会，为广大会员和工作者服务；
            </p>
            <p>
              实施科教兴国和可持续发展战略，促进工程建设人才的成长与提高，为加快民生建设，促进四川经济繁荣和工程建设可持续发展做出贡献。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/breadCrumb.vue";
export default {
  components: { Breadcrumb },
  data() {
    return {
      breadcrumbs: [],
    };
  },
  methods: {},
  created() {
    this.breadcrumbs = [
      { path: "/", name: "首页" },
      { name: this.$route.name },
    ];
  },
};
</script>

<style lang="scss" scoped>
.frame {
  background-color: #f9f9f9;

  &::after {
    content: "";
    display: table;
  }
}
.wrap {
  width: 1200px;
  margin: 0 auto 20px;
  background-color: #fff;
  box-shadow: 0 0 5px #eee;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;

  .title-box {
    width: fit-content;
    margin: 50px auto;
    text-align: center;

    .title {
      padding: 5px 0;
      font-size: 28px;
      font-weight: bold;
      position: relative;

      &::before {
        content: "";
        width: 40px;
        height: 2px;
        background-color: $theme;
        position: absolute;
        right: -60px;
        top: 50%;
        transform: translateY(-50%);
      }
      &::after {
        content: "";
        width: 40px;
        height: 2px;
        background-color: $theme;
        position: absolute;
        left: -60px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .box .content {
    .intro {
      width: 900px;
      margin: 20px auto;
      text-indent: 2em;
      line-height: 2;
    }

    .origin {
      span {
        font-size: 25px;
        color: $theme;
        font-weight: bold;
        margin: 0 10px;
      }
    }
    .type-title {
      width: fit-content;
      color: #fff;
      margin: 30px auto;
      font-size: 22px;
      padding: 10px 30px;
      background-color: $theme;
    }
    .types {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      text-align: center;

      .type {
        width: 50%;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }

    .hope {
      width: 900px;
      margin: 0 auto 50px;
      text-indent: 2em;
      line-height: 2;
    }
  }

  .scope {
    .content {
      padding: 20px 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .left .list {
        width: 500px;
        color: #666;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item {
          min-width: 50%;
          margin-bottom: 10px;
          text-align: center;
        }
      }
      .right {
        width: 600px;
        margin-left: 50px;
      }
    }
  }
}
</style>
